    import React                from "react";
    import TextField            from "@mui/material/TextField";

    function CustomNumberAggiunta({ name, label, onChange, values, maxLength, maxQty, setAlert, disabled, onBlur }) {
        const handleChange = (e) => {
            const { name, value } = e.target;
        
            if (/^\d*$/.test(value)) {
                onChange({ [name]: value });
            }
        };
        
        const handleBlur = () => {
            const currentValue = parseInt(values[name], 10);
    
            if (currentValue > maxQty) {
                onChange({ [name]: "" }); // Resetta il valore
                setAlert({
                    open: true,
                    message: `Non è possibile inserire una quantità maggiore di ${maxQty}.`,
                    severity: "warning",
                });
            }
    
            if (onBlur) {
                onBlur();
            }
        };

    return (
        <TextField
        name={name}
        label={label}
        type="text"
        variant="outlined"
        fullWidth
        disabled={disabled}
        inputProps={{
            maxLength: maxLength,
        }}
        value={values[name] || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        sx={{
            width: "100%",
            textAlign: "left",
            borderRadius: "10px",
            backgroundColor: "#FFFFFF", 
            "& .MuiOutlinedInput-root": {
                "& fieldset": {
                    borderColor: "#fda03d",
                },
                "&:hover fieldset": {
                borderColor: "#fda03d", 
                },
                "&.Mui-focused fieldset": {
                borderColor: "#fda03d", 
                },
            },
            "& .MuiOutlinedInput-root.Mui-disabled": {
                bgcolor: "transparent",
                cursor: "not-allowed",
            },
            "& .Mui-disabled": {
                cursor: "not-allowed",
            },
            "& .MuiInputLabel-root.Mui-focused": {
                color: "#fda03d", 
            },
            }}
        />
    );
    }

    export default CustomNumberAggiunta;
